module.exports = __webpack_public_path__ + "static/media/logowanie-mob-swieta.f2f49836.png";